<template>
  <div class="function-debugging">
    <div v-if="!isLoading" class="function-debugging__wrapper">
      <div class="row">
        <div class="col col-12 col-md-6 col-xl-4">
          <c-input
            v-model="form.status"
            type="select"
            floating-label="Показатель"
            :items="collections.statuses"
          />
        </div>
      </div>

      <div class="function-debugging__tasks">
        <h3 class="function-debugging__tasks-title">Задачи по отладке функции</h3>
        <draggable
          v-model="form.tasks"
          group="group"
          :force-fallback="true"
          ghost-class="sortable__ghost"
          :disabled="form.tasks.length < 2"
        >
          <div v-for="(task, i) in form.tasks" class="function-debugging__tasks-item row" :key="task.id">
            <div class="col col-10 col-md-10 col-xl-10">
              <c-input
                :ref="'task-' + i"
                type="textarea"
                v-model="task.value"
                floating-label="Описание задачи"
                :clearable="true"
              />
            </div>
            <div class="function-debugging__tasks-item-actions col col-2 col-md-2 col-xl-2">
              <c-button
                v-if="form.tasks.length > 1"
                v-b-popover.hover.blur.top="'Удалить'"
                class="function-debugging__tasks-item-remove"
                :icon="{ icon: 'trash', color: 'secondary' }"
                size="iconic"
                @click="deleteTask(task.id)"
              />
              <c-button
                v-if="form.tasks.length > 1"
                class="function-debugging__tasks-item-move"
                v-b-popover.html="{
                  container: '#app',
                  trigger: 'hover blur',
                  boundary: 'window',
                  content: 'Переместить',
                  placement: 'top',
                }"
                size="iconic"
                icon="arrows-constructor"
              />
            </div>
          </div>
        </draggable>

        <p v-if="!form.tasks.length" class="function-debugging__empty">Задач пока не добавлено</p>
        <div class="row">
          <div class="col col-xl-12 col-md-12 col-12">
            <c-button
              :responsive="true"
              size="small"
              label="Добавить задачу"
              :icon="{ icon: 'plus', color: 'primary' }"
              @click="addTask"
              :disabled="addTaskIsDisabled"
            />
          </div>
        </div>
      </div>

      <div class="function__actions" :class="{'function__actions--fixed': actionsIsFixed}">
        <c-button class="function__action" label="Отменить" size="large" @click="onReset" />
        <c-button class="function__action" label="Сохранить" size="large" color="primary" @click="onSubmit" />
      </div>

      <!-- <responsive-apply-reset-actions
        @on-submit="onSubmit"
        @on-reset="onReset"
        :fixed="true"
      /> -->
    </div>

    <c-loader
      v-if="isLoading"
      label="Данные загружаются"
      :active="isLoading"
      height="400"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CButton from "@/components/controls2/Button";
import CInput from "@/components/controls2/Input";
import ResponsiveApplyResetActions from "@/components/responsive-apply-reset-actions";
import draggable from "vuedraggable";
import Loader from "@/components/loader";

export default {
  name: "function-debugging",

  components: {
    "c-button": CButton,
    "c-input": CInput,
    "c-loader": Loader,
    draggable,
    ResponsiveApplyResetActions,
  },

  async created() {
    this.isLoading = true;

    await this.$store.dispatch("functions/getStatusesList").then((res) => {
      this.collections.statuses = res.map(item => ({
        value: item.id,
        label: item.name,
        formatLabel: this.icons.find(icon => icon.id === item.id).value + ' ' + item.name,
        resultLabel: this.icons.find(icon => icon.id === item.id).value + ' ' + item.name,
      }))

      if (this.functionModel && this.functionModel.status) this.form.status = this.collections.statuses.find(status => Number(status.value) === Number(this.functionModel.status.id))
    })

    await this.setDataFromFunctionModel();

    let flag = true;

    let interval = setInterval(() => {
      if (flag) {
        let layoutHeader = document.querySelector('.function .layout-header');
        let layoutSubheader = document.querySelector('.function .subheader');
        let functionContent = document.querySelector('.function .function__content');
        
        let sumContentHeight = layoutHeader.scrollHeight + layoutSubheader.scrollHeight + functionContent.scrollHeight

        if (functionContent) {
          if (sumContentHeight + 50 > document.documentElement.clientHeight) {
            setTimeout(() => {
              this.actionsIsFixed = true
            }, 500);
            
            flag = false;
            clearInterval(interval)
          } else {
            this.actionsIsFixed = false
          }
        }
      }
    }, 100);

    this.isLoading = false;
  },

  data() {
    return {
      isLoading: false,
      tasksIdsCounter: 0,
      actionsIsFixed: false,

      form: {
        status: "",
        tasks: []
      },

      collections: {
        statuses: [],
      },

      icons: [
        {
          id: 1,
          value: 
          `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 2V8.5M10.4253 3.07318C11.9816 4.15718 13 5.95965 13 8C13 11.3137 10.3137 14 7 14C3.68629 14 1 11.3137 1 8C1 5.95965 2.01843 4.15718 3.57468 3.07318" stroke="#0066FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `
        },
        {
          id: 2,
          value: 
          `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 4.5V7.5L9 8.5M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z" stroke="#FFB800" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `
        },
        {
          id: 3,
          value: 
          `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 6.5L7 8.5C7 8.5 10.3284 5.17157 11.5 4M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z" stroke="#12C971" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `
        },
        {
          id: 4,
          value: 
          `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 7.5H9M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `
        },
        {
          id: 5,
          value: 
          `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 5.5L9 9.5M9 5.5L5 9.5M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z" stroke="#FF238D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `
        },
      ]
    }
  },
  computed: {
    ...mapState({
      functionModel: (state) => state.functions.functionModel,
    }),
    addTaskIsDisabled() {
      let disabled = false;

      if (this.form.tasks.length) {
        disabled = true;

        if (this.form.tasks[this.form.tasks.length -1].value) disabled = false
      }

      return disabled
    },
  },
  methods: {
    addTask() {
      this.form.tasks.push({id: this.tasksIdsCounter, value: ""})
      this.tasksIdsCounter++
    },
    deleteTask(taskId) {
      this.form.tasks = this.form.tasks.filter(task => task.id !== taskId);
    },
    onReset() {
      this.setDataFromFunctionModel()
    },
    async onSubmit() {
      let params = {
        page: "debugging",
        id: this.functionModel.id,
        statusId: this.form.status.value,
        checkoutTasks: this.form.tasks
      }

      await this.$store.dispatch("functions/updateFunction", params).then(res => {
        if (res.success) {
          this.$notify({
            group: "success-message",
            data: {
              textMessage: `Отладка для функции успешно сохранена`,
            },
          });
        } else {
          Vue.notify({
            group: "error-message",
            data: {
              textMessage: `Произошла ошибка. Попробуйте ещё раз`,
            },
          });
        }
      })
    },
    setDataFromFunctionModel() {
      this.form.status = this.collections.statuses.find(status => Number(status.value) === Number(this.functionModel.status.id))

      this.form.tasks = [];

      if (this.functionModel.checkoutTasks.length) {
        this.functionModel.checkoutTasks.forEach((task, i) => {
          this.form.tasks.push({id: this.tasksIdsCounter, value: task})

          setTimeout(() => {          
            this.$refs[`task-${i}`][0].setValue(task)
            this.$refs[`task-${i}`][0].textValue = task
            this.$refs[`task-${i}`][0].$refs.textareaValue.innerHTML = task
          }, 500);

          this.tasksIdsCounter++
        })
      }
    }
  },
  watch: {
    functionModel: {
      handler() {
        this.setDataFromFunctionModel()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.function-debugging {
  padding-top: 36px;
  .row {
    margin-bottom: 25px;
  }

  &__tasks {
    margin-top: 40px;
    
    &-title {
      font-size: 18px;
      font-weight: 500;
      margin: 0 0 25px;
    }

    &-item {
      align-items: center;
      padding: 20px 0;
      margin-top: -20px;
      margin-bottom: 5px!important;

      &-actions {
        display: flex;
        align-items: center;
      }

      &-move {
        margin-left: 15px;
        margin-bottom: -4px;
      }
    }
  }

  &__empty {
    color: #8E9CBB;
    line-height: 100%;
  }
}
</style>